import { type ColorTokens, isWeb, VisuallyHidden } from "tamagui";
import { TextSpan } from "./Typography";

// A span, not a Caption: Caption renders a <p>, and a <p> can't nest inside a
// label's own <p> — the browser would close the outer tag early, splitting the
// accessible name.
export function RequiredMark({
  color = "$textNegative"
}: {
  color?: ColorTokens;
}) {
  return <TextSpan aria-hidden color={color} data-sentry-element="TextSpan" data-sentry-component="RequiredMark" data-sentry-source-file="RequiredMark.tsx">
      {" "}
      *
    </TextSpan>;
}

// The asterisk is decorative, so a required label has to say "required" some
// other way. On native, nested Text merges into its parent's accessible name
// (aria-hidden alone would still read "star"), so the label takes a name
// override. Web ignores aria-label on the <p> a text label renders, so there
// the word rides in hidden text instead.
export const requiredLabelName = (label: string, required: boolean | undefined): string | undefined => required && !isWeb ? `${label}, required` : undefined;
export function RequiredCue({
  required
}: {
  required: boolean | undefined;
}) {
  if (!required) {
    return null;
  }
  return <>
      <RequiredMark data-sentry-element="RequiredMark" data-sentry-source-file="RequiredMark.tsx" />
      {isWeb ? <VisuallyHidden>, required</VisuallyHidden> : null}
    </>;
}